module.exports = __webpack_public_path__ + "img/1970East-021_WEB-min.11046a39.jpg";